import { PrecoModel } from './preco.model';
import { GrupoProdutoModel } from './grupo-produto.model';
export class ProdutoModel {
  id: number;
  codigo: String;
  descricao: String;
  peso: number;
  altura: number;
  largura: number;
  profundidade: number;
  empMaximo: number;
  recipienteAlocacao: number;
  qtsAlocavel: number;
  aliqICMS: number;
  cod: number;
  grupoProdutoServico: GrupoProdutoModel;
  precoProdutoServicos: Array<PrecoModel[]>;
}



// WEBPACK FOOTER //
// /app/src/app/model/produto/produto.model.ts